/**
 * Shared chrome for HR / TPRM / Audit enterprise dashboards (M7).
 */
import React from 'react';
import ModalShell from './ModalShell';
import PanelHeader from './PanelHeader';
import { buttons, cn } from './uiTokens';

interface EnterpriseDashboardShellProps {
  title: string;
  subtitle?: string;
  icon?: string;
  onClose: () => void;
  children: React.ReactNode;
  tabs?: React.ReactNode;
  headerExtra?: React.ReactNode;
  className?: string;
  testId?: string;
}

const EnterpriseDashboardShell: React.FC<EnterpriseDashboardShellProps> = ({
  title,
  subtitle,
  icon,
  onClose,
  children,
  tabs,
  headerExtra,
  className,
  testId,
}) => (
  <ModalShell
    onClose={onClose}
    zLevel="modalHigh"
    dismissOnOverlay
    testId={testId}
    className={cn('max-w-7xl w-full', className)}
  >
    <div className="bg-slate-900 rounded-lg border border-slate-600 shadow-xl max-h-[95vh] overflow-hidden flex flex-col">
      <div className="flex items-center justify-between border-b border-slate-700 shrink-0 pr-4 md:pr-5">
        <PanelHeader
          title={title}
          subtitle={subtitle}
          icon={icon}
          onClose={headerExtra ? undefined : onClose}
          className="flex-1 border-b-0"
        />
        {(headerExtra || onClose) && (
          <div className="flex items-center gap-4 shrink-0">
            {headerExtra}
            {headerExtra && onClose && (
              <button
                type="button"
                onClick={onClose}
                className={cn(buttons.icon, 'text-xl')}
                aria-label="Close"
              >
                ✕
              </button>
            )}
          </div>
        )}
      </div>
      {tabs}
      <div className="flex-1 overflow-y-auto p-4 md:p-6">{children}</div>
    </div>
  </ModalShell>
);

export default EnterpriseDashboardShell;